import { z } from 'zod';
import { idSchema, dateSchema, emailSchema, urlSchema, optionalDateSchema } from './common';

/**
 * USER API SCHEMAS
 * Guards against malformed user profile and identity responses.
 */

export const careerGoalSchema = z.object({
  date: dateSchema,
  goal: z.string().default('')
});

export const userProfileSchema = z.object({
  id: idSchema,
  name: z.string().default('Unknown User'),
  email: z.string().email().or(z.string()).default(''),
  email2: emailSchema,
  type: z.string().optional(),
  clientId: idSchema.optional(),
  avatar: urlSchema,
  createdAt: optionalDateSchema,
  updatedAt: optionalDateSchema,
  linkedin: urlSchema,
  title: z.string().optional(),
  company: z.string().optional(),
  city: z.string().optional(),
  country: z.string().optional(),
  timezone: z.string().optional(),
  status: z.string().optional(),
  careerGoals: z.array(careerGoalSchema).default([])
});

export type UserProfileResponse = z.infer<typeof userProfileSchema>;
